import { createAction } from '@af-common/Common/_actions/Action';

export enum LayerListActionType {
	OnLayerAdd					= 'ON_LAYER_ADD',
	OnLayerRemove				= 'ON_LAYER_REMOVE',
	OnLayerSelect				= 'ON_LAYER_SELECT',
	OnLayerMove					= 'ON_LAYER_MOVE',
	OnLayerRename				= 'ON_LAYER_RENAME',
	OnLayerVisibility			= 'ON_LAYER_VISIBILITY',
	OnLayerListVisibilityToggle	= 'ON_LAYER_LIST_VISIBILITY_TOGGLE',
	OnLayerListVisibility		= 'ON_LAYER_LIST_VISIBILITY',
}

export const OnLayerAdd = () => createAction(LayerListActionType.OnLayerAdd);

export const OnLayerRemove = (id: string) => createAction(LayerListActionType.OnLayerRemove, {
	id: id
});

export const OnLayerSelect = (id: string) => createAction(LayerListActionType.OnLayerSelect, {
	id: id
});

export const OnLayerMove = (id: string, offset:number) => createAction(LayerListActionType.OnLayerMove, {
	id: id,
	offset: offset
});

export const OnLayerRename = (id: string, name:string) => createAction(LayerListActionType.OnLayerRename, {
	id: id,
	name: name
});

export const OnLayerVisibility = (id: string, visible:boolean) => createAction(LayerListActionType.OnLayerVisibility, {
	id: id,
	visible: visible
});

export const OnLayerListVisibilityToggle = () => createAction(LayerListActionType.OnLayerListVisibilityToggle);
export const OnLayerListVisibility = (visible: boolean) => createAction(LayerListActionType.OnLayerListVisibility, {
	visible: visible
});

export type LayerListAction = 
	ReturnType<typeof OnLayerAdd>			|
	ReturnType<typeof OnLayerRemove>		|
	ReturnType<typeof OnLayerSelect>		|
	ReturnType<typeof OnLayerMove>			|
	ReturnType<typeof OnLayerRename>		|
	ReturnType<typeof OnLayerVisibility>	|
	ReturnType<typeof OnLayerListVisibilityToggle>	|
	ReturnType<typeof OnLayerListVisibility>